// src/frontend/js/modern/modules/wishlist/store.js

import { BaseStore } from '../../shared/store-helpers.js';

class WishlistStore extends BaseStore {
	constructor() {
		super('wishlist', 'product_id');
	}
}

export const wishlistModuleStore = new WishlistStore();
export default wishlistModuleStore;
